import * as React from "react";
import { forwardRef } from "react";
const JcbIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("mask", {
  id: "jcb-icon_svg__a",
  width: 37,
  height: 28,
  x: 5,
  y: 10,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M42 10H5v28h37z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#jcb-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M42 32.2611c0 3.098-2.5783 5.6207-5.7445 5.6207H5V15.6206C5 12.5226 7.57824 10 10.7445 10H42z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#jcb-icon_svg__b)",
  d: "M31.8227 26.5521h2.3748c.0678 0 .2262-.0221.294-.0221.4523-.0885.8368-.4868.8368-1.0401 0-.531-.3845-.9293-.8368-1.0399-.0678-.0222-.2035-.0222-.294-.0222h-2.3748z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#jcb-icon_svg__c)",
  d: "M33.926 11.8809c-2.2616 0-4.1161 1.7924-4.1161 4.0274v4.1822h5.8124c.1357 0 .2939 0 .407.0222 1.3117.0664 2.2843.7302 2.2843 1.8809 0 .9072-.6559 1.6817-1.8772 1.8366v.0443c1.3343.0885 2.3521.8187 2.3521 1.9473 0 1.217-1.1308 2.0136-2.6235 2.0136h-6.3778v8.1876h6.0386c2.2616 0 4.1161-1.7924 4.1161-4.0274V11.8809z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#jcb-icon_svg__d)",
  d: "M35.0343 22.2592c0-.5311-.3846-.8852-.8368-.9515-.0453 0-.1584-.0222-.2262-.0222h-2.1486v1.9473h2.1486c.0678 0 .2035 0 .2262-.0221.4522-.0664.8368-.4204.8368-.9515"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#jcb-icon_svg__e)",
  d: "M11.1742 11.8809c-2.26163 0-4.11615 1.7924-4.11615 4.0274v9.9356c1.15342.5532 2.35207.9073 3.55075.9073 1.4248 0 2.1937-.8408 2.1937-1.9915v-4.6913h3.5282v4.6691c0 1.8145-1.1535 3.2972-5.0661 3.2972-2.37465 0-4.22917-.509-4.22917-.509v8.4751h6.03847c2.2617 0 4.1162-1.7924 4.1162-4.0273V11.8809z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#jcb-icon_svg__f)",
  d: "M22.5501 11.8809c-2.2616 0-4.1161 1.7924-4.1161 4.0274v5.2665c1.0404-.863 2.8496-1.4162 5.7671-1.2834 1.5605.0664 3.234.4868 3.234.4868v1.7039c-.8367-.4204-1.8318-.7966-3.121-.8851-2.2164-.1549-3.5507.9072-3.5507 2.766 0 1.8809 1.3343 2.9431 3.5507 2.766 1.2892-.0885 2.2843-.4867 3.121-.8851v1.7039s-1.6509.4204-3.234.4869c-2.9175.1326-4.7267-.4204-5.7671-1.2835v9.2939h6.0385c2.2617 0 4.1161-1.7924 4.1161-4.0273V11.8809z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb-icon_svg__b",
  x1: -169.838,
  x2: 846.471,
  y1: 130.908,
  y2: 130.908,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007940"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2285,
  stopColor: "#00873F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7433,
  stopColor: "#40A737"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5CB531"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb-icon_svg__c",
  x1: 39.9766,
  x2: 29.8594,
  y1: 24,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#28B86B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#125230"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb-icon_svg__d",
  x1: -169.864,
  x2: 846.485,
  y1: 118.373,
  y2: 118.373,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007940"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2285,
  stopColor: "#00873F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7433,
  stopColor: "#40A737"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5CB531"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb-icon_svg__e",
  x1: 17.1406,
  x2: 7.02343,
  y1: 24,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#273182"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#080A1C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb-icon_svg__f",
  x1: 28.5586,
  x2: 18.4414,
  y1: 24,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D02D3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6A171F"
}))));
const ForwardRef = forwardRef(JcbIcon);
export { ForwardRef as JcbIcon };